import { createAction, props } from '@ngrx/store';
import { NicknameRequest } from '../../shared/models/Nickname';
import { selectedRowData, selectedRowDataSLOA } from '../../shared/types/TableComponentState';
import { ServiceError } from '../models/shared/ServiceError';
import { StandingAuthTableColumn } from '../../shared/types/StandingAuthTableColumn';
import { CashieringTransaction, RecurringTransaction, Sloa } from '../models';
import { standingAuthTableTabName } from '../../shared/utilities/Constants';

export const gridReady = createAction(
  '[Create Request - Standing Authorizations Table] AG Grid Ready',
  props<{ gridReady: boolean}>()
)

export const refresh = createAction(
  '[Create Request - Standing Authorizations Table] Refresh Overview Data',
  props<{ accountId: string }>()
);

export const printClicked = createAction(
  '[Standing Authorizations Table] User Requested Printout'
);

export const startTransactionClicked = createAction(
  '[Create Request - Standing Authorizations Table] Start Transaction',
  props<{ rowData: selectedRowData }>()
);

export const startTransacionFlowComplete = createAction(
  '[Create Request - Standing Authorizations Table] Start Transaction Completed'
);

export const editProfileClicked = createAction(
  '[Standing Authorizations Table] Edit Profile',
  props<{ rowData: selectedRowData }>()
);

export const editTransactionFlowComplete = createAction(
  '[Create Request - Standing Authorizations Table] Edit Transaction Completed'
);

export const loadViewPage = createAction(
  '[Create Request - Standing Authorizations Table] Load View Page'
);

export const addUpdateDeleteNickname = createAction(
  '[Create Request - Standing Authorizations Table] Add/Update/Delete Nickname',
  props<{ rowData: selectedRowDataSLOA, requestType: string }>()
);

export const addUpdateDeleteNicknameSuccess = createAction(
  '[Create Request - Standing Authorizations Table] Add/Update/Delete Nickname completed successfully',
  props<NicknameRequest>()
);

export const addUpdateDeleteNicknameFailure = createAction(
  '[Create Request - Standing Authorizations Table] Add/Update/Delete Nickname failure',
  props<ServiceError>()
);

export const setCurrentViewedStandingAuth = createAction(
  '[Create Request - Standing Authorizations Table] - Map Standing Authorization',
  props<{ rowData: StandingAuthTableColumn}>()
);

export const deleteTransactionClicked = createAction(
  '[Create Request - Standing Authorizations Table] Delete Transaction',
  props<{ transaction: CashieringTransaction | RecurringTransaction | Sloa, shouldRetry?: boolean, isNewAchProfile?: boolean }>()
);

export const deleteTransactionSuccess = createAction(
  '[Create Request - Standing Authorizations Table] Delete Succeeded',
  props<{ isNewAchProfile: boolean }>()
);

export const deleteTransactionFailure = createAction(
  '[Create Request - Standing Authorizations Table] Delete Failed',
  props<{ errorMsg: string}>()
);

export const deleteTransactionFailurePendingTransaction = createAction(
  '[Create Request - Standing Authorizations Table] Delete Failed Pending Transaction',
  props<{ errorMsg: string}>()
);

export const resetSubmitCancelTransactionState = createAction(
  "[Create Request - Standing Authorizations Table] - Reset SubmitDeleteStandingAuthState to default"
)

export const currentTabUpdated = createAction(
  '[Standing Authorizations Table] User changed tab',
  props<{currentTab: standingAuthTableTabName}>()
);
